"use strict";
let carsMap, carsInfoWindow, carsModal;
async function initHotelsMap() {
    carsMap = new google.maps.Map(document.getElementById("cars-aside-map"), {
        center: { lat: DEFUALT_LATITUDE, lng: DEFUALT_LONGITUDE },
        zoom: 10,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true, 
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });
    carsInfoWindow = new google.maps.InfoWindow();
}
async function initHotelsFullMap() {
    carsMap = new google.maps.Map(document.getElementById("cars-full-map"), {
        center: { lat: DEFUALT_LATITUDE, lng: DEFUALT_LONGITUDE },
        zoom: 10,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });
    carsInfoWindow = new google.maps.InfoWindow();
}
document.addEventListener("DOMContentLoaded", () => {
    initHotelsMap();
    initHotelsFullMap();
    const RoomReservationModalElm = document.querySelector('#RoomReservationModal');
    if(RoomReservationModalElm){
        console.log('RoomReservationModalElm:',RoomReservationModalElm); 
        const RoomReservationModal = new mdb.Modal(RoomReservationModalElm);
        RoomReservationModalElm.addEventListener('shown.mdb.modal', (e) => {
            var RRForm_DateRange = new Lightpick({
                field: document.getElementById('RRForm_DateRange'),
                singleDate: false,
                inline: true,
                numberOfColumns: 2,
                numberOfMonths: 2,
                // onSelect: function(start, end){
                //     var str = '';
                //     str += start ? start.format('Do MMMM YYYY') + ' to ' : '';
                //     str += end ? end.format('Do MMMM YYYY') : '...';
                //     document.getElementById('result-2').innerHTML = str;
                // }
            });
        });
    }
    
   
    var HSForm_DateRangeElm=document.getElementById('HSForm_DateRange');
    if(HSForm_DateRangeElm){
        var picker = new Lightpick({
            field: document.getElementById('HSForm_DateRange'),
            singleDate: false,
            inline: true,
            numberOfColumns: 2,
            numberOfMonths: 2,
            // onSelect: function(start, end){
            //     var str = '';
            //     str += start ? start.format('Do MMMM YYYY') + ' to ' : '';
            //     str += end ? end.format('Do MMMM YYYY') : '...';
            //     document.getElementById('result-2').innerHTML = str;
            // }
        });
    }
    
    
    // 

    // const carsSearchPageElm = document.querySelector(`#cars-search-page`);
    // const listViewSectionElm = carsSearchPageElm.querySelector(`#cars-list-view`);
    // const listMapSectionElm = carsSearchPageElm.querySelector(`#cars-map-view`); 
    // const carsCloseMapBtnElm = carsSearchPageElm.querySelectorAll(`.close-map-btn`);
    // const carsShowMapBtnElm = carsSearchPageElm.querySelectorAll(`.show-map-btn`);
    // carsShowMapBtnElm.forEach(btn=> {
    //     btn.addEventListener('click',async ()=> {
    //         listViewSectionElm.classList.add('d-none');
    //         listMapSectionElm.classList.remove('d-none');
    //     });
    // });
    // carsCloseMapBtnElm.forEach(btn=> {
    //     btn.addEventListener('click',async ()=> {
    //         listMapSectionElm.classList.add('d-none');
    //         listViewSectionElm.classList.remove('d-none');
    //     });
    // });
    // const HotelsSearchFormElm = document.querySelector(`#HotelsSearchForm`);
    // const fromDate_DatepickerElm = HotelsSearchFormElm.querySelector(`#HSForm_FromDate_datepicker`);
    // const FromDateDatepicker = new mdb.Datepicker(fromDate_DatepickerElm, DATEPICKER_OPTIONS);
    // const toDate_DatepickerElm = HotelsSearchFormElm.querySelector(`#hsf_toDate_Datepicker`); 
    // DATEPICKER_OPTIONS.disablePast=false;

    // const FromDateDatepicker = new mdb.Datepicker(fromDate_DatepickerElm, DATEPICKER_OPTIONS);
    // const ToDateDatepicker = new mdb.Datepicker(toDate_DatepickerElm, DATEPICKER_OPTIONS);
    // const hsf_sortElm = HotelsSearchFormElm.querySelector(`#hsf_sort`); 
    // hsf_sortElm.addEventListener('click',async ()=> { 
    //     HotelsSearchFormElm.querySelector(`#hsf_sort_dropdown`).classList.add('show'); 
    // });
    // const hsf_sort_update_btnElm = HotelsSearchFormElm.querySelector(`#hsf_sort_update_btn`); 
    // hsf_sort_update_btnElm.addEventListener('click',async ()=> { 
    //     HotelsSearchFormElm.querySelector(`#hsf_sort_dropdown`).classList.remove('show'); 
    // });
});